var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"mb-6 font-weight-black text-h4",class:this.textColor},[_vm._v(" Not Found ")]),_c('p',{staticClass:"mb-6 font-weight-medium",class:this.textColor},[_vm._v(" URLをお確かめください… ")])])}
var staticRenderFns = []

export { render, staticRenderFns }